import CircularProgress from '@mui/material/CircularProgress';

const Loader = ({ customStyle, hasBackground = false }) => {
  return (
    <div className={`${hasBackground && 'fixed top-0 left-0 w-full h-full bg-white/50'} z-50`}>
      <div className={`absolute  ${customStyle}`}>
        <CircularProgress
          color="inherit"
          size={80}
          className="text-ITSP_blue"
        />
      </div>
    </div>
  );
};

export default Loader;
